var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Loading',{attrs:{"active":_vm.loading,"is-full-page":false,"opacity":0},on:{"update:active":function($event){_vm.loading=$event}}}):_c('PrinterListBody',{attrs:{"printers":_vm.printers,"printRequest":_vm.printRequest,"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }